<template>
    <Card>
        <div class="card-body">
            <router-link
                class="btn btn-link legitRipple"
                :to="{
                    name: 'SmsTemplatesCreatePage'
                }"
            >
                <i class="icon-plus3 mr-2"></i>
                {{ translate('buttons.create') }}
            </router-link>
        </div>
        <FetchTable :handle="tableHandle" :columns="columns" :url="url">
            <template #td-id="{ row }">
                <router-link :to="{ name: 'SmsTemplatesEditPage', params: { smsTemplateUuid: row.uuid } }">
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-api_credentials="{ row }">
                {{ row.api_credentials.name }}
                <span :class="['badge', row.api_credentials.is_active ? 'badge-success' : 'badge-danger', 'ml-2']">
                    {{ row.api_credentials.is_active ? $t('labels.active') : $t('labels.inactive') }}
                </span>
            </template>
            <template #td-text="{ row }">
                {{ formatText(row.text) }}
            </template>
            <template #td-send_once="{ row }">
                {{ row.send_once ? $t('labels.yes') : $t('labels.no') }}
            </template>
            <template #td-created_at="{ row }">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";

import DateFormatter from "../../../../services/DateFormatter";
import { httpClient } from "../../../../services/HttpClient";

export default {
    name: "SmsTemplatesIndexPage",
    components: {
        Card, FetchTable
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            url: `/projects/${this.$route.params.projectUuid}/crm/sms-templates`,
            columns: [
                { key: 'id', name: this.$t('table.titles.id'), width: '150px', type: 'string', order: false },
                { key: 'name', name: this.$t('labels.name'), width: '200px', type: 'string', order: false },
                { key: 'api_credentials', name: this.$t('table.titles.api_credentials'), width: '200px', type: 'string', order: false },
                { key: 'text', name: this.$t('table.titles.text'), width: '200px', type: 'string', order: false },
                { key: 'send_once', name: this.$t('table.titles.send_once'), width: '200px', type: 'string', order: false },
                { key: 'created_at', name: this.$t('table.titles.created_at'), width: '200px', type: 'string', order: false },
            ],
            orderCustomFields: []
        }
    },
    computed: {
        formulaItems() {
            let items = [
                {code: '{$deliveryCompanyNumber}', name: this.$t('labels.ttn')},
                {code: '{$orderSum}', name: this.$t('labels.order_sum')},
                {code: '{$orderExternalId}', name: this.$t('labels.order_external_id')},
            ];

            this.orderCustomFields.forEach((field) => {
                items.push({
                    name: field.name,
                    code: `{$customField[${field.uuid}]}`
                });
            });

            return items;
        }
    },
    methods: {
        fetchOrderCustomFields() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/custom-fields`, {
                limit: 100
            }).then((response) => {
                this.orderCustomFields = response.data.data
            })
        },
        formatText(text) {
            if (!text) return text;

            let formattedText = text;
            this.formulaItems.forEach(item => {
                const regex = new RegExp(item.code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
                formattedText = formattedText.replace(regex, item.name);
            });

            return formattedText;
        }
    },
    mounted() {
        this.fetchOrderCustomFields();
        this.tableHandle.fetchRows()
    }
}
</script>
